//! DO NOT IMPORT FROM THIS FILE - USE './theme-selectors.ts' INSTEAD
export var getTypeFontName = function (theme) {
    return theme.v1.typography.fontName;
};
export var getTypeFontURL = function (theme) {
    return theme.v1.typography.fontUrl;
};
export var getDefaultTypeStack = function (theme) {
    return theme.v1.typography.defaultStack;
};
export var getFabrigaMedium = function (theme) {
    return "\"Fabriga Medium\", \"Fabriga Regular\", ".concat(theme.v1.typography.fontName, ", ").concat(theme.v1.typography.defaultStack);
};
export var getFabrigaRegular = function (theme) {
    return "".concat(theme.v1.typography.fontName, ", \"Fabriga Regular\", ").concat(theme.v1.typography.defaultStack);
};
export var getDefaultFontSizeMin = function (theme) {
    return theme.v1.typography.typeScale.default.fontSize.min;
};
export var getDefaultLineHeightMin = function (theme) {
    return theme.v1.typography.typeScale.default.lineHeight.min;
};
export var getRegularFontWeightName = function (theme) {
    return theme.v1.typography.fontWeights.regular.name;
};
export var getRegularFontWeight = function (theme) {
    return theme.v1.typography.fontWeights.regular.weight;
};
export var getLightFontWeightName = function (theme) {
    return theme.v1.typography.fontWeights.light.name;
};
export var getLightFontWeight = function (theme) {
    return theme.v1.typography.fontWeights.light.weight;
};
export var getMediumFontWeightName = function (theme) {
    return theme.v1.typography.fontWeights.medium.name;
};
export var getMediumFontWeight = function (theme) {
    return theme.v1.typography.fontWeights.medium.weight;
};
export var getBoldFontWeightName = function (theme) {
    return theme.v1.typography.fontWeights.bold.name;
};
export var getBoldFontWeight = function (theme) {
    return theme.v1.typography.fontWeights.bold.weight;
};
// CHEROKEE
export var getCherokeeFontSizeMin = function (theme) {
    return theme.v1.typography.typeScale.cherokee.fontSize.min;
};
export var getCherokeeFontSizeMax = function (theme) {
    return theme.v1.typography.typeScale.cherokee.fontSize.max;
};
export var getCherokeeLineHeightMin = function (theme) {
    return theme.v1.typography.typeScale.cherokee.lineHeight.min;
};
export var getCherokeeLineHeightMax = function (theme) {
    return theme.v1.typography.typeScale.cherokee.lineHeight.max;
};
export var getCherokeeLetterSpacing = function (theme) {
    return theme.v1.typography.typeScale.cherokee.letterSpacing;
};
export var getCherokeeFontWeight = function (theme) {
    return theme.v1.typography.typeScale.cherokee.fontWeight;
};
// HUMMER
export var getHummerFontSizeMin = function (theme) {
    return theme.v1.typography.typeScale.hummer.fontSize.min;
};
export var getHummerFontSizeMax = function (theme) {
    return theme.v1.typography.typeScale.hummer.fontSize.max;
};
export var getHummerLineHeightMin = function (theme) {
    return theme.v1.typography.typeScale.hummer.lineHeight.min;
};
export var getHummerLineHeightMax = function (theme) {
    return theme.v1.typography.typeScale.hummer.lineHeight.max;
};
export var getHummerLetterSpacing = function (theme) {
    return theme.v1.typography.typeScale.hummer.letterSpacing;
};
export var getHummerFontWeight = function (theme) {
    return theme.v1.typography.typeScale.hummer.fontWeight;
};
// DISCOVERY
export var getDiscoveryFontSizeMin = function (theme) {
    return theme.v1.typography.typeScale.discovery.fontSize.min;
};
export var getDiscoveryFontSizeMax = function (theme) {
    return theme.v1.typography.typeScale.discovery.fontSize.max;
};
export var getDiscoveryLineHeightMin = function (theme) {
    return theme.v1.typography.typeScale.discovery.lineHeight.min;
};
export var getDiscoveryLineHeightMax = function (theme) {
    return theme.v1.typography.typeScale.discovery.lineHeight.max;
};
export var getDiscoveryFontWeight = function (theme) {
    return theme.v1.typography.typeScale.discovery.fontWeight;
};
// PHANTOM
export var getPhantomFontSizeMin = function (theme) {
    return theme.v1.typography.typeScale.phantom.fontSize.min;
};
export var getPhantomFontSizeMax = function (theme) {
    return theme.v1.typography.typeScale.phantom.fontSize.max;
};
export var getPhantomLineHeightMin = function (theme) {
    return theme.v1.typography.typeScale.phantom.lineHeight.min;
};
export var getPhantomLineHeightMax = function (theme) {
    return theme.v1.typography.typeScale.phantom.lineHeight.max;
};
export var getPhantomFontWeight = function (theme) {
    return theme.v1.typography.typeScale.phantom.fontWeight;
};
// INSIGNIA
export var getInsigniaFontSizeMin = function (theme) {
    return theme.v1.typography.typeScale.insignia.fontSize.min;
};
export var getInsigniaFontSizeMax = function (theme) {
    return theme.v1.typography.typeScale.insignia.fontSize.max;
};
export var getInsigniaLineHeightMin = function (theme) {
    return theme.v1.typography.typeScale.insignia.lineHeight.min;
};
export var getInsigniaLineHeightMax = function (theme) {
    return theme.v1.typography.typeScale.insignia.lineHeight.max;
};
export var getInsigniaFontWeight = function (theme) {
    return theme.v1.typography.typeScale.insignia.fontWeight;
};
// TOLEDO
export var getToledoFontSizeMin = function (theme) {
    return theme.v1.typography.typeScale.toledo.fontSize.min;
};
export var getToledoFontSizeMax = function (theme) {
    return theme.v1.typography.typeScale.toledo.fontSize.max;
};
export var getToledoLineHeightMin = function (theme) {
    return theme.v1.typography.typeScale.toledo.lineHeight.min;
};
export var getToledoLineHeightMax = function (theme) {
    return theme.v1.typography.typeScale.toledo.lineHeight.max;
};
export var getToledoFontWeight = function (theme) {
    return theme.v1.typography.typeScale.toledo.fontWeight;
};
// PICANTO
export var getPicantoFontSizeMin = function (theme) {
    return theme.v1.typography.typeScale.picanto.fontSize.min;
};
export var getPicantoFontSizeMax = function (theme) {
    return theme.v1.typography.typeScale.picanto.fontSize.max;
};
export var getPicantoLineHeightMin = function (theme) {
    return theme.v1.typography.typeScale.picanto.lineHeight.min;
};
export var getPicantoLineHeightMax = function (theme) {
    return theme.v1.typography.typeScale.picanto.lineHeight.max;
};
export var getPicantoLetterSpacing = function (theme) {
    return theme.v1.typography.typeScale.picanto.letterSpacing;
};
export var getPicantoFontWeight = function (theme) {
    return theme.v1.typography.typeScale.picanto.fontWeight;
};
// FIESTA
export var getFiestaFontSizeMin = function (theme) {
    return theme.v1.typography.typeScale.fiesta.fontSize.min;
};
export var getFiestaLineHeightMin = function (theme) {
    return theme.v1.typography.typeScale.fiesta.lineHeight.min;
};
export var getFiestaFontWeight = function (theme) {
    return theme.v1.typography.typeScale.fiesta.fontWeight;
};
// BEETLE
export var getBeetleFontSizeMin = function (theme) {
    return theme.v1.typography.typeScale.beetle.fontSize.min;
};
export var getBeetleFontSizeMax = function (theme) {
    return theme.v1.typography.typeScale.beetle.fontSize.max;
};
export var getBeetleLineHeightMin = function (theme) {
    return theme.v1.typography.typeScale.beetle.lineHeight.min;
};
export var getBeetleLineHeightMax = function (theme) {
    return theme.v1.typography.typeScale.beetle.lineHeight.max;
};
export var getBeetleFontWeight = function (theme) {
    return theme.v1.typography.typeScale.beetle.fontWeight;
};
// SMART
export var getSmartFontSizeMin = function (theme) {
    return theme.v1.typography.typeScale.smart.fontSize.min;
};
export var getSmartFontSizeMax = function (theme) {
    return theme.v1.typography.typeScale.smart.fontSize.max;
};
export var getSmartLineHeightMin = function (theme) {
    return theme.v1.typography.typeScale.smart.lineHeight.min;
};
export var getSmartLineHeightMax = function (theme) {
    return theme.v1.typography.typeScale.smart.lineHeight.max;
};
export var getSmartFontWeight = function (theme) {
    return theme.v1.typography.typeScale.smart.fontWeight;
};
// PRIUS
export var getPriusFontSizeMin = function (theme) {
    return theme.v1.typography.typeScale.prius.fontSize.min;
};
export var getPriusLineHeightMin = function (theme) {
    return theme.v1.typography.typeScale.prius.lineHeight.min;
};
export var getPriusFontWeight = function (theme) {
    return theme.v1.typography.typeScale.prius.fontWeight;
};
// MINI
export var getMiniFontSizeMin = function (theme) {
    return theme.v1.typography.typeScale.mini.fontSize.min;
};
export var getMiniLineHeightMin = function (theme) {
    return theme.v1.typography.typeScale.mini.lineHeight.min;
};
export var getMiniFontWeight = function (theme) {
    return theme.v1.typography.typeScale.mini.fontWeight;
};
